import { SubscriptionUrgencyLevel } from 'utils';

export const REPORTS_PAGE_URL = 'reports';
export const INCOMES_PAGE_URL = 'incomes';
export const EXPENSES_PAGE_URL = 'expenses';
export const PAGE_URL_KEY = 'pageUrl';

export const characterGroups = [
  ['i', 'I', 'ı', 'İ'],
  ['o', 'O', 'ö', 'Ö'],
  ['u', 'U', 'ü', 'Ü'],
  ['c', 'C', 'ç', 'Ç'],
  ['s', 'S', 'ş', 'Ş'],
  ['g', 'G', 'ğ', 'Ğ'],
  ['a', 'A', 'â', 'Â'],
  ['e', 'E', 'ə', 'Ə'],
];

export const ADD_NEW_MANAGER_DEFAULT_VALUES = {
  name: '',
  id: '',
};

export const langsMap = [
  { key: 'az', value: 'Azərbaycanca' },
  { key: 'en', value: 'English' },
  { key: 'ru', value: 'Русский' },
];

// Date format that will be used consistently
export const dateFormatList = ['DD.MM.YYYY'];

// Format used for date display in the component
export const DATE_FORMAT = 'DD.MM.YYYY';

export const tableHeaderStyle = {
  color: '#466afb !important',
  fontSize: '15px !important',
  fontWeight: `500 !important`,
};

export const OUTGOING_INVOICES_ID = 'outgoing_invoices';

export const STATUS_PAID = 2;
export const STATUS_UNPAID = 3;
export const STATUS_ALL = 'all';

export const landingHeaderlinks = (translation) => {
  return [
    {
      name: translation.home.Header.Product,
      url: 'product',
      external: false,
    },
    {
      name: translation.home.Header.Solutions,
      url: 'features',
      external: false,
    },
    {
      name: translation.home.Header.Company,
      url: 'https://digera-world.com/',
      external: true,
    },
    {
      name: translation.home.Header.Pricing,
      url: 'pricing',
      external: false,
    },
    {
      name: translation.home.Header.Contact,
      url: 'contact',
      external: false,
    },
  ];
};

export const DIALOG_CLOSE_STATUS_BACKDROP = 'backdropClick';

export const RESTRICTED_COUNTRY_ID = 12;

export const BANK_TRANSFER_REPORT_KEY = 'bank-transfer-report';
export const CANCELLED_REPORT_KEY = 'cancelled-report';
export const CASH_FLOW_REPORT_KEY = 'cash_flow_report_key';
export const CUSTOMER_CREDITOR_BALANCE_REPORT_KEY =
  'customer_creditor_balance_report_key';
export const CUSTOMER_DEBITOR_BALANCE_REPORT_KEY =
  'customer_debitor_balance_report_key';
export const INCOMES_AND_EXPENSES_REPORT_KEY = 'incomes_expenses_report_key';
export const JOB_NUMBER_REPORT_KEY = 'job_number_report_key';
export const MANAGER_REPORT_KEY = 'manager_report_key';
export const MEASUREMENT_REPORT_KEY = 'measurement_report_key';
export const SALE_TYPES_REPORT_KEY = 'sale_types_report_key';
export const TAX_TYPES_REPORT_KEY = 'tax_types_report_key';

export const DEFAULT_PAYMENT_CURRENCY_CODE = '944';
export const DEFAULT_PAYMENT_CURRENCY_TEXT = 'AZN';

export const urgencyPanelStyles: Record<SubscriptionUrgencyLevel, string> = {
  0: 'bg-[#c5ebfd] text-[#1D1D1D]',
  1: 'bg-[#ffe4cc] text-[#8a4b12]',
  2: 'bg-[#e05353] font-semibold text-[#9b1c1c]',
  3: 'bg-[#ef0000] font-semibold text-white',
};

export const urgencyIcons: Record<SubscriptionUrgencyLevel, string> = {
  0: '⭐',
  1: '⏳',
  2: '⚠️',
  3: '🔔',
};

export const urgencyButtonStyles: Record<SubscriptionUrgencyLevel, string> = {
  0: 'bg-[#466afb] text-white hover:bg-[#3a57d9]',
  1: 'bg-[#8a4b12] text-white hover:bg-[#6f3c0e]',
  2: 'bg-white text-[#9b1c1c] hover:bg-gray-100',
  3: 'bg-white text-[#ef0000] hover:bg-gray-100',
};
